export const FULL_PORTION = 1000000;
